import { OPERATION_SOFTWARE_ID } from 'routes/BudgetModule/config/constants';
import { ApT } from '../types';

export const AMOUNT_FIELD = 'secondaryBudgetAxisElementAmount';
export const REALIZED_FIELD = 'opAmountRealized';
const PERCENT_REALIZED_FIELD = 'opPercentRealized';

export type ApOperationsT = ApT & {
    [AMOUNT_FIELD]: number;
    [REALIZED_FIELD]: number;
    [PERCENT_REALIZED_FIELD]: number;
    [OPERATION_SOFTWARE_ID]: string;
};
